import { roundFloatToCentsAsDollar } from "@hydra/internal";
import { Paper, Typography, Divider, Box } from "@mui/material";

//TODO add this to hydra shared as it is used on the backend aswell
interface IInvoicePreviewProps {
  preview: {
    invoiceNumber: string;
    address: {
      organization?: string;
      street?: string;
      street2?: string;
      city?: string;
      province?: string;
      country?: string;
      postalCode?: string;
    };
    items: {
      item: string;
      description: string;
      unitCost: number;
      quantity: number;
      lineTotal: number;
    }[];
    taxTotal: number;
    total: number;
    currency: string;
  };
  index: number;
}

const tableStyles: React.CSSProperties = {
  width: '100%',
  borderCollapse: 'collapse',
  marginTop: '20px',
};

const cellStyles: React.CSSProperties = {
  border: '1px solid #d81b60',
  padding: '12px',
  fontSize: '14px',
};

const headerStyles: React.CSSProperties = {
  ...cellStyles,
  backgroundColor: '#ad1457',
  color: '#ffffff',
  textAlign: 'left',
  fontWeight: 'bold',
};

const rowStyles = (isEven: boolean): React.CSSProperties => ({
  backgroundColor: isEven ? '#f8bbd0' : '#f48fb1',
  color: '#000000',
});

const emojis = ["🔪", "🎉", "🚀", "🌟", "🔥", "💎"];
const getRandomEmoji = () => emojis[Math.floor(Math.random() * emojis.length)];

export const InvoicePreview = ({ preview, index }: IInvoicePreviewProps) => {
  return (
    <Paper
      key={index}
      variant="outlined"
      elevation={0}
      sx={{
        p: 4,
        borderRadius: 3,
        boxShadow: 6,
        background: "#fce4ec",
        borderColor: "#ad1457",
        color: "#000000",
      }}
    >
      <Box textAlign="center" mb={3}>
        <Typography variant="h4" fontWeight="bold" color="#ad1457">
          {getRandomEmoji()} {preview.invoiceNumber}
        </Typography>
        <Typography variant="subtitle1" color="#757575">
          Invoice Preview
        </Typography>
      </Box>
      <Divider sx={{ mb: 3, borderColor: "#ad1457" }} />
      <Typography fontWeight="bold" mb={1} color="#ad1457">Billing Address:</Typography>
      <Typography color="#424242">
        {preview.address.organization ?? ''}<br />
        {preview.address.street ?? ''} {preview.address.street2 ?? ''}<br />
        {preview.address.city ?? ''}, {preview.address.province ?? ''}, {preview.address.country ?? ''}<br />
        {preview.address.postalCode ?? ''}
      </Typography>
      <Divider sx={{ my: 3, borderColor: "#ad1457" }} />
      <Typography fontWeight="bold" mb={1} color="#ad1457">Items:</Typography>
      <table style={tableStyles}>
        <thead>
          <tr>
            <th style={headerStyles}>Item</th>
            <th style={headerStyles}>Description</th>
            <th style={{ ...headerStyles, textAlign: 'right' }}>Quantity</th>
            <th style={{ ...headerStyles, textAlign: 'right' }}>Unit Cost</th>
            <th style={{ ...headerStyles, textAlign: 'right' }}>Line Total</th>
          </tr>
        </thead>
        <tbody>
          {preview.items.map((item, itemIndex) => (
            <tr key={itemIndex} style={rowStyles(itemIndex % 2 === 0)}>
              <td style={cellStyles}>{item.item}</td>
              <td style={cellStyles}>{item.description}</td>
              <td style={{ ...cellStyles, textAlign: 'right' }}>{item.quantity}</td>
              <td style={{ ...cellStyles, textAlign: 'right' }}>{roundFloatToCentsAsDollar(item.unitCost)}</td>
              <td style={{ ...cellStyles, textAlign: 'right' }}>{roundFloatToCentsAsDollar(item.lineTotal)}</td>
            </tr>
          ))}
          <tr style={rowStyles(false)}>
            <td colSpan={4} style={{ ...cellStyles, textAlign: 'right', fontWeight: 'bold' }}>
              Tax Total:
            </td>
            <td style={{ ...cellStyles, textAlign: 'right' }}>
              {roundFloatToCentsAsDollar(preview.taxTotal)} {preview.currency}
            </td>
          </tr>
          <tr style={rowStyles(true)}>
            <td colSpan={4} style={{ ...cellStyles, textAlign: 'right', fontWeight: 'bold' }}>
              Total:
            </td>
            <td style={{ ...cellStyles, textAlign: 'right' }}>
              {roundFloatToCentsAsDollar(preview.total)} {preview.currency}
            </td>
          </tr>
        </tbody>
      </table>
    </Paper>
  );
};
